import React from "react";

import { QuickWorkOrderDetailsDialog } from "../../dialogs";
import { useScheduleContext } from "../../hooks";

import ScheduleBar from "./ScheduleBar";
import { getContainer } from "./helper";
import { Stack } from "@mui/material";

const Scheduler = () => {
  const { open, setOpen = () => {}, tab } = useScheduleContext();
  const DisplayTab = getContainer(tab);

  return (
    <Stack width="100%" height="100%" overflow="hidden">
      <ScheduleBar mode="scheduler" />
      <DisplayTab />
      <QuickWorkOrderDetailsDialog id={open} setOpen={setOpen} />
    </Stack>
  );
};

export default Scheduler;
